import React from "react";

import { IIssueN } from "../../../../state";
import { zeroPaddingText } from "../../../../libs/Util";

import AnswerBlock from "./AnswerBlock";
import styles from "./IssueList.module.scss";

const isHomeworkIssue = (title: string) =>
  title.replace(/\s/g, "").toUpperCase() === "HOMEWORK";

const getIssueDisplayTitle = (
  title: string,
  retrospectiveTitle: string | undefined,
): string => {
  if (isHomeworkIssue(title)) return title;
  if (title === retrospectiveTitle || /^ふりかえり/i.test(title))
    return "振り返り";
  if (/^ワーク/.test(title))
    return zeroPaddingText(title).replace("ワーク", "WORK");
  return title;
};

const sortIssues = (issues: IIssueN[]): IIssueN[] => {
  const homework = issues.filter(i => isHomeworkIssue(i.title));
  const others = issues.filter(i => !isHomeworkIssue(i.title));
  return [...others.sort((a, b) => a.id - b.id), ...homework];
};

type Props = {
  issues: IIssueN[];
  isLeaf?: boolean;
  isMiddleOrHigh: boolean;
  calling: boolean;
  currentStudentId: number;
  handleComment: (
    answerId: number,
    content: string,
    commentId?: number,
  ) => void;
  handleDeleteComment: (answerId: number, commentId: number) => void;
};

const IssueList: React.FC<Props> = ({
  issues,
  isLeaf = false,
  isMiddleOrHigh,
  calling,
  currentStudentId,
  handleComment,
  handleDeleteComment,
}) => {
  const sorted = sortIssues(issues);
  const retrospectiveTitle =
    isMiddleOrHigh && !isLeaf
      ? [...sorted].reverse().find(i => /^ワーク/.test(i.title))?.title
      : undefined;

  return (
    <>
      {sorted.map(issue => (
        <div key={issue.id} className={styles.issueBlock}>
          <span className={styles.issueTitle}>
            {getIssueDisplayTitle(issue.title, retrospectiveTitle)}
          </span>
          {issue.answers.map(answer => (
            <AnswerBlock
              key={answer.id}
              answer={answer}
              calling={calling}
              currentStudentId={currentStudentId}
              handleComment={handleComment}
              handleDeleteComment={handleDeleteComment}
            />
          ))}
        </div>
      ))}
    </>
  );
};

export default IssueList;
